import { useParams } from '@tanstack/react-router';
import { getEventAttendances } from 'src/graphql/queries/events.graphql';
import type {
  IGetEventAttendancesQuery,
  IGetEventAttendancesQueryVariables,
} from 'src/graphql/queries/events.graphql.types';
import { useQuery } from 'urql';
import useRootUserRevalidation from '../useRootUserRevalidation';

const useEventAttendees = ({ ticketId }: { ticketId?: number }) => {
  const { eventId } = useParams({ strict: false });

  const [{ data, error, fetching, stale }, refetch] = useQuery<
    IGetEventAttendancesQuery,
    IGetEventAttendancesQueryVariables
  >({
    query: getEventAttendances,
    variables: { eventId: Number(eventId), ticketId },
    requestPolicy: 'cache-and-network',
    pause: true,
  });

  const attendeeCharactersOf = ({ playerId }: { playerId: number }) => {
    return (
      data?.event?.eventAttendees
        ?.find(x => x.user.id === playerId)
        ?.attendeeCharacters.map(x => x.character) ?? []
    );
  };

  useRootUserRevalidation({ refetch });

  return {
    data,
    error,
    fetching,
    stale,
    refetch,
    attendees: data?.event?.eventAttendees || [],
    attendeeCharactersOf,
  };
};

export default useEventAttendees;
